export * from './affix-ids.js';
const ARMOUR = ['helmet', 'chest', 'gloves', 'boots', 'offhand'];
/*
 * Six affixes may fall on every slot, a legendary takes three: twenty
 * possible sets per slot, so two boots of the same template rarely carry the
 * same kinds. Each slot mixes the three stats (all but the weapon) with
 * three of the fight's own affixes.
 */
export const AFFIXES = Object.freeze({
    dps: {
        label: '+{v} DPS',
        slots: ['weapon', ...ARMOUR],
        scale: 'power',
        min: 0.25,
        max: 0.6,
        step: 0.1,
    },
    health: { label: '+{v} Vie', slots: ARMOUR, scale: 'power', min: 1.2, max: 3, step: 1 },
    defence: { label: '+{v} Défense', slots: ARMOUR, scale: 'power', min: 0.7, max: 1.8, step: 1 },
    'crit-chance': {
        label: '+{v} % de chance de critique',
        slots: ['weapon', 'helmet', 'gloves', 'boots'],
        scale: 'flat',
        min: 2,
        max: 5,
        step: 1,
        // Up to 25 % with the base 10 % (`CRIT_CHANCE`).
        cap: 15,
    },
    'crit-damage': {
        label: '+{v} % de dégâts critiques',
        slots: ['weapon', 'gloves'],
        scale: 'flat',
        min: 10,
        max: 25,
        step: 1,
        // Up to ×2 with the base ×1.5 (`CRIT_MULTIPLIER`).
        cap: 50,
    },
    cooldown: {
        label: '-{v} % de recharge des sorts',
        slots: ['weapon', 'helmet', 'chest', 'offhand'],
        scale: 'flat',
        min: 3,
        max: 8,
        step: 1,
        cap: 20,
    },
    energy: {
        label: '+{v} énergie par seconde',
        slots: ['helmet', 'chest', 'boots', 'offhand'],
        scale: 'flat',
        min: 0.6,
        max: 1.5,
        step: 0.1,
        // Up to 9 a second with the base 6 (`ENERGY_PER_SECOND`).
        cap: 3,
    },
    lifesteal: {
        label: '{v} % des dégâts rendus en vie',
        slots: ['weapon', 'chest', 'gloves'],
        scale: 'flat',
        min: 2,
        max: 5,
        step: 1,
        cap: 10,
    },
    'boss-damage': {
        label: '+{v} % de dégâts aux boss et élites',
        slots: ['weapon', 'boots', 'offhand'],
        scale: 'flat',
        min: 5,
        max: 12,
        step: 1,
        cap: 30,
    },
});
/** How many affixes a piece of this rarity carries. */
export const AFFIX_COUNT = Object.freeze({
    common: 0,
    rare: 1,
    epic: 2,
    legendary: 3,
});
/** The runesmith (ADR 0057): Sablerouge and Givrecime, the same work in both. */
export const RUNESMITH_MOB_ID = 'runesmith';
export const RUNESMITH_BIOMES = ['desert', 'snow'];
/** How close to a runesmith a player must stand, in tiles, diagonals included. */
export const RUNESMITH_REACH = 2;
/**
 * A reroll's gold, in multiples of the smith's base cost of the piece's biome
 * (`UPGRADE_BASE_COST`): the price of an attempt at +7, 1.35^7 ≈ 8.
 */
export const REFORGE_GOLD_FACTOR = 8;
/**
 * Relics of the piece's biome to seal a rune for good: it never changes
 * again, and costs nothing to keep at every later reroll. Dearer than a
 * single keep (one relic) because it pays for all of them at once.
 */
export const SEAL_RELICS = 3;
//# sourceMappingURL=affixes.js.map